/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_LayoutsInputs */

const en_mk_mx_layouts = /** @type {(inputs: Mk_Mx_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List, board and table views`)
};

const id_mk_mx_layouts = /** @type {(inputs: Mk_Mx_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan daftar, papan, dan tabel`)
};

/**
* | output |
* | --- |
* | "List, board and table views" |
*
* @param {Mk_Mx_LayoutsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_layouts = /** @type {((inputs?: Mk_Mx_LayoutsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_LayoutsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_layouts(inputs)
	return en_mk_mx_layouts(inputs)
});